import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
/**
 * A series of utils for the Titan Text class.
 */
export class GameTextUtil {
    constructor() { }
    /**
     * Titan text has issues with vertical alignment when using bounded size. This fixes the position to be as expected.
     */
    static centerProperties(...texts) {
        for (const text of texts) {
            if (text.verticalAlign === ControlConstants.CENTER) {
                const size = (text.size?.y) ?? 0;
                text.position.y -= size / 2;
                continue;
            }
            else if (text.verticalAlign === ControlConstants.BOTTOM) {
                const size = (text.size?.y) ?? 0;
                text.position.y -= size;
            }
        }
    }
}
//# sourceMappingURL=GameTextUtils.js.map